import im from 'immutable';

const ActionTypes = {
  REGISTER_VIEW: '@@acast-react-redux-view/REGISTER_VIEW',
};

const Identity = new im.Map();

export default (state = Identity, action) => {
  switch (action.type) {
    case ActionTypes.REGISTER_VIEW:
      if (state.get(action.viewId)) {
        return state;
      }

      return state.merge({
        [action.viewId]: new im.Map({
          viewId: action.viewId,
          viewState: action.reducer(
            state[action.viewId] ? state[action.viewId].viewState : undefined,
            action
          ),
        }),
      });

    default: {
      if (!action.viewId) {
        return state;
      }

      // Pass along the action if there's a view with that viewId
      const view = state.get(action.viewId);
      if (view) {
        return state.set(
          action.viewId,
          view.merge({
            viewState: action.reducer(view.get('viewState'), action),
          })
        );
      }

      return state;
    }
  }
};
